import Link from "next/link";
import type { GeoLink } from "@/lib/page-data/geo-links";

export type GeoNavigationItem = Pick<GeoLink, "path" | "productName" | "label">;

export function GeoNavigationLinks({ links, title }: { links: GeoNavigationItem[]; title: string }) {
  if (links.length === 0) return null;

  return (
    <nav aria-label={title} className="space-y-3">
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <h2 className="text-base font-semibold text-foreground">{title}</h2>
        <Link href="/html-sitemap" prefetch={false} className="text-sm text-action hover:underline">
          All locations →
        </Link>
      </div>
      <ul className="grid gap-x-6 gap-y-2 text-sm sm:grid-cols-2 lg:grid-cols-3">
        {links.map((link) => (
          <li key={link.path}>
            <Link href={link.path} prefetch={false} className="text-action hover:underline">
              {link.productName} in {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
